// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2647":"eb5898a278487488","2888":"bbe9c1166cb4f2f6","7297":"eb5898a278487488"}[chunkId] + ".css";
};